import Vue from 'vue';
import VueToastr from 'vue-toastr';
import VueLocalStorage from 'vue-localstorage';
import App from './App.vue';
import router from './router';

import firebaseConfig from './firebaseConfig';

firebaseConfig.analytics();

Vue.use(VueToastr, {
  defaultTimeout: 2000,
  defaultProgressBar: false,
  defaultStyle: {
    'background-color': 'black',
  },
  defaultPosition: 'toast-top-full-width',
});

Vue.use(VueLocalStorage);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
